import React from 'react';
import {Heading, Modal, Text} from '@forecast-it/design-system';
import {useIntl} from 'react-intl';

interface Props {
	clientName: string;
	onAddContacts: () => void; // TODO IGNITE-contacts: wire to create-contact flow when available
	onSkip: () => void;
}

const CreateContactConfirmModal = ({clientName, onAddContacts, onSkip}: Props): JSX.Element => {
	const {formatMessage} = useIntl();

	return (
		<Modal onCloseModal={onSkip}>
			<Modal.Title>
				<Heading size={3}>{formatMessage({id: 'clients_page.create_contact_confirm.title'})}</Heading>
			</Modal.Title>

			<Modal.Content>
				<Text>{formatMessage({id: 'clients_page.create_contact_confirm.body'}, {clientName})}</Text>
			</Modal.Content>

			<Modal.Footer>
				<Modal.PrimaryFooterButton onPress={onAddContacts}>
					{formatMessage({id: 'clients_page.create_contact_confirm.yes'})}
				</Modal.PrimaryFooterButton>

				<Modal.SecondaryFooterButton onPress={onSkip}>
					{formatMessage({id: 'clients_page.create_contact_confirm.skip'})}
				</Modal.SecondaryFooterButton>
			</Modal.Footer>
		</Modal>
	);
};

export default CreateContactConfirmModal;
